/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerInsuranceInovalonPayer
 */
export interface ScreenerInsuranceInovalonPayer {
    /**
     * 
     */
    payer_name: string;
    /**
     * 
     */
    payer_identification_number: string;
}

/**
 * Check if a given object implements the ScreenerInsuranceInovalonPayer interface.
 */
export function instanceOfScreenerInsuranceInovalonPayer(value: object): value is ScreenerInsuranceInovalonPayer {
    if (!('payer_name' in value) || value['payer_name'] === undefined) return false;
    if (!('payer_identification_number' in value) || value['payer_identification_number'] === undefined) return false;
    return true;
}

export function ScreenerInsuranceInovalonPayerFromJSON(json: any): ScreenerInsuranceInovalonPayer {
    return ScreenerInsuranceInovalonPayerFromJSONTyped(json, false);
}

export function ScreenerInsuranceInovalonPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerInsuranceInovalonPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'payer_name': json['payer_name'],
        'payer_identification_number': json['payer_identification_number'],
    };
}

export function ScreenerInsuranceInovalonPayerToJSON(json: any): ScreenerInsuranceInovalonPayer {
    return ScreenerInsuranceInovalonPayerToJSONTyped(json, false);
}

export function ScreenerInsuranceInovalonPayerToJSONTyped(value?: ScreenerInsuranceInovalonPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payer_name': value['payer_name'],
        'payer_identification_number': value['payer_identification_number'],
    };
}

